import { CalculsFormNewPerteGainsProfessionnelsActuels } from '@norma/shared/constants/calculs';
import { MonetaryErosion } from '@norma/shared/types/monetaryErosion.type';
import { NewPrejudiceFormPerteGainProfessionnelsActuel } from '@norma/shared/types/prejudice.type';
import { Procedure } from '@norma/shared/types/procedure.type';
import { Paragraph, Table, TableOfContents } from 'docx';
import { getEmptyLine } from '../../../docxFunctions';
import { debitSoldeEchusPrint } from '../../debitSoldeEchusPrint';
import { prejudiceNotesPrint } from '../../prejudiceNotesPrint';
import { stepsPrint } from './stepsPrint';
import { tableRecapitulatifPrint } from './tableRecapitulatifPrint';

export const newPerteGainsProfessionnelsActuelsPrint = (
  procedure: Procedure,
  formData: NewPrejudiceFormPerteGainProfessionnelsActuel,
  monetaryErosions: MonetaryErosion[],
): (Paragraph | Table | TableOfContents)[] => {
  const notesPrint = prejudiceNotesPrint(formData.notes);
  const indemniteGlobaleARepartir =
    CalculsFormNewPerteGainsProfessionnelsActuels.getIndemnitesRepartie({
      ...formData,
      perteGainProfessionnelsTotal: formData.perteDeGainsProfessionnels.total,
      indemnitesJournalieresPercuesPendantLaPeriodeDArretCsgRdsTotal:
        formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret
          .csgRdsTotal,
      indemnitesJournalieresPercuesPendantLaPeriodeDArretIndemnitesJournalieresPercuesNet:
        formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret
          .indemnitesJournalieresPercuesNet,
      indemnitesJournalieresPercuesPendantLaPeriodeDArretRows:
        formData.indemnitesJournalieresPercuesPendantLaPeriodeDArret.rows,
      partResponsabilite: procedure.partResponsabilite,
    });
  const tableRecapitulatif = tableRecapitulatifPrint(
    formData,
    procedure.partResponsabilite,
  );
  const steps = stepsPrint({
    formData,
    monetaryErosions,
    dateLiquidation: procedure.dateLiquidation
      ? new Date(procedure.dateLiquidation)
      : null,
    isPGPF: false,
  });
  const debitSoldeTable = debitSoldeEchusPrint({
    indemniteGlobaleARepartir,
    partResponsabilite: procedure.partResponsabilite,
  });

  return [
    getEmptyLine(),
    ...(notesPrint ? [notesPrint] : []),
    getEmptyLine(),
    ...steps,
    getEmptyLine(),
    ...tableRecapitulatif,
    getEmptyLine(),
    ...debitSoldeTable,
  ];
};
